import { createBridgeClient } from '@ps/common-features/lib/api/config/clientBridge'

import { BASE_URL, BRIDGE_API_KEY, BRIDGE_BASE_URL } from './constants'

export const apiClientBridge = createBridgeClient(BASE_URL, BRIDGE_BASE_URL, BRIDGE_API_KEY, {
  skipAuthentication: true,
})
